import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../static/css/AdminSchedule.css";

function PublicationPage() {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [event, setEvent] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      date: selectedDate ? selectedDate.toISOString().split("T")[0] : null,
      time: selectedTime ? selectedTime.toTimeString().split(" ")[0] : null,
      event,
      description,
    };

    try {
      const response = await fetch("https://skpbackend.quindl.com/schedule/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const result = await response.json();
        alert("Event added successfully!");
        console.log(result);
      } else {
        alert("Failed to add event.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error submitting form.");
    }
  };

  return (
    <div className="Admincontrol">
      <div className="schedule-form">
        <form>
          <label htmlFor="date">Date</label>
          <div className="input-with-icon">
            <DatePicker
              selected={selectedDate}
              onChange={setSelectedDate}
              dateFormat="dd/MM/yyyy"
              placeholderText="Select date"
              className="date-picker-input"
              calendarClassName="custom-calendar"
              wrapperClassName="date-picker-wrapper"
            />
          </div>
          <label htmlFor="time">Time</label>
          <div className="input-with-icon">
            <DatePicker
              selected={selectedTime}
              onChange={setSelectedTime}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="h:mm aa"
              placeholderText="Select time"
              className="date-picker-input"
              calendarClassName="custom-time-picker"
              wrapperClassName="date-picker-wrapper"
            />
          </div>
          <label htmlFor="event">Event</label>
          <input
            type="text"
            id="event"
            value={event}
            placeholder="Enter event name"
            onChange={(e) => setEvent(e.target.value)}
          />
          <label htmlFor="description">Event Description</label>
          <textarea
            id="description"
            value={description}
            placeholder="Enter event description"
            onChange={(e) => setDescription(e.target.value)}
          />
          <button type="submit" onClick={handleSubmit}>
            Update
          </button>
        </form>
      </div>
    </div>
  );
}

export default PublicationPage;
